<template>
  <div>
    <simpletoolbar></simpletoolbar>
    <section class="section" style="padding-top:1rem;">
      <ga-id></ga-id>
      <hr>
      <account-dump></account-dump>
    </section>
  </div>
</template>

<script setup>
import simpletoolbar from '@components/ui/simpletoolbar.vue';
import gaId from '@components/admin/gaId.vue';
import accountDump from '@components/admin/accountDump.vue';
</script>
